import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'

import styles from '../ProtocolsController.module.sass'
import Skeleton from '@jimmyboys/liita-ui/dist/components/Skeleton'

const ProtocolRow = (props) => {
	const { i18n } = useGlobal()
	const { data, ...attributes } = props
	const { type, processId } = data

	return (
		<HStack
			{...attributes}
			className={styles['protocol-row']}
			paddings={['small', 'normal', '']}
			justify='space-between'
			gap='xsmall'
			align='center'
		>
			<small>
				<strong>{i18n.translate(type)}</strong>
			</small>
			<Link to={`/clinical-processes/${processId}/appointments`}>
				<small>#{processId}</small>
			</Link>
		</HStack>
	)
}

export const ProtocolRowSkeleton = (props) => {
	const { className, ...attributes } = props
	return (
		<div
			{...attributes}
			className={`${styles['row-skeleton']} ${className || ''}`}
		>
			<span>
				<small>
					<Skeleton className={styles['skeleton']} />
				</small>
			</span>
			<span>
				<small>
					<Skeleton
						className={`${styles['skeleton']} ${styles['small']}`}
					/>
				</small>
			</span>
		</div>
	)
}

export const ProtocolHeader = (props) => {
	const { i18n } = useGlobal()
	return (
		<HStack
			className={styles['protocol-row']}
			paddings={['small', 'normal', '']}
			justify='space-between'
			gap='xsmall'
			align='center'
		>
			<small>
				<strong>{i18n`Protocol Type`}</strong>
			</small>
			<small>
				<strong>{i18n`Process ID`}</strong>
			</small>
		</HStack>
	)
}

export default ProtocolRow
